<template>
  <div>
    <div class="sayfahead">
      <h1><span v-if="!Cari_id">{{Sayfa.Adi}}</span><br></h1>
      <el-button v-if="Yetki && Kaydet" type="success" size="small" class="YeniBtn" @click="this.Submit"
                 icon="el-icon-check">{{Sayfa.ButtonAdi}}
      </el-button>

    </div>
    <div class="icerik hyok">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :rules="FormHata" :model="Form"
               @submit.prevent.native="Submit"
               ref="GiderForm"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select @change="BinaSecimi" v-model="Form.Bina_id" filterable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-popover
              v-if="AnlasmaliFirmalar && Form.Bina_id"
              placement="top"
              width="400"
              trigger="hover">

              <el-link type="warning" size="mini" class="btn-block FirmaButon"
                       v-for="Firma in AnlasmaliFirmalar"
                       @click="Anlasma(Firma)">
                <p class="FirmaButonFirma">
                  <small>Firma</small>
                  {{Firma.CariText}}
                </p>
                <p class="FirmaButonKategori">
                  <small>Kategori</small>
                  {{Firma.KategoriText}}
                </p>
                <p class="FirmaButonAciklama">
                  <small>Açıklama</small>
                  {{Firma.Aciklama}}
                </p>
              </el-link>

              <el-button size="mini" class="float-right" style="top: -10px;position: relative;"
                         slot="reference">
                Anlaşmalı Firma Listesi
              </el-button>
            </el-popover>
          </el-col>
          <el-col :span="6" v-if="!Cari_id">
            <el-form-item label="Firma" prop="Cari_id">
              <el-select v-model="Form.Cari_id" filterable>
                <el-option
                  v-for="item in Cariler"
                  :key="item.id"
                  :label="item.Unvan"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Kategori" prop="Kategori_id">
              <el-cascader
                collapse-tags
                :options="Kategoriler"
                v-model="Form.Kategori_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Evrak No" prop="eNo">
              <el-input v-model="Form.eNo"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="Tutar" prop="Tutar">
              <el-input v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="Borçlanma Tarihi" prop="tTarihi">
              <el-date-picker
                v-model="Form.tTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Son Ödeme Tarihi" prop="sTarihi">
              <el-date-picker
                v-model="Form.sTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="Sitemi?9:10">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="Sitemi">
            <el-form-item class="Tooltip" label="Böl" prop="Bol">
              <el-tooltip class="item" effect="dark"
                          content="Binalara eşit oranda böler"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch :disabled="OdemeKapali || TekrarKapali" v-model="Form.Bol"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="Form.Bol">
            <el-form-item class="Tooltip" label="Daire Sayısı" prop="Daire">
              <el-tooltip class="item" effect="dark"
                          content="Binaların daire sayılarına göre oranla"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="Form.Daire"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="!Form.Bol">
            <el-form-item label="Ödeme" prop="Odeme">
              <el-switch :disabled="OdemeKapali" v-model="Form.Odeme"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="!Form.Bol">
            <el-form-item label="Tekrarla" prop="Tekrar">
              <el-switch :disabled="TekrarKapali" v-model="Form.Tekrar"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="Form.Odeme">
          <hr>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="Ödeme Tarihi" prop="oTarihi">
                <el-date-picker
                  v-model="Form.oTarihi"
                  type="date"
                  placeholder=""
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Kasa" prop="Kasa_id">
                <el-cascader
                  collapse-tags
                  :props="{ multiple: false}"
                  :options="Kasalar"
                  v-model="Form.Kasa_id"
                  filterable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="Form.Tekrar">
          <hr>
          <el-row :gutter="24">

            <el-col :span="3">
              <el-form-item label="Tekrar Sayısı" prop="TekrarSayisi">
                <el-input-number v-model="Form.TekrarSayisi" :precision="0" :step="1" :min="1"
                                 :max="12"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Gün Döngüsü" prop="GunDongusu">
                <el-input-number v-model="Form.GunDongusu" :precision="0" :step="1" :min="1"
                                 :max="28"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="Tekrar Adı" prop="TaksitAdi">
                <el-switch v-model="Form.TaksitAdi"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="Ay Adı" prop="AyAdi">
                <el-switch v-model="Form.AyAdi"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="Tutarı Böl" prop="AnaPara">
                <el-switch v-model="Form.AnaPara"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <br>
              <el-button type="warning" @click="TaksitPlani" size="small">Tekrar Planı Oluştur</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="Taksitler">
            <hr>
            <el-col :span="24">
              <table class="table table-hover table-xs table-hover">
                <thead>
                <tr>
                  <th colspan="4" class="text-center">Tekrar Önizlemesi</th>
                </tr>
                <tr>
                  <th width="50">Sıra</th>
                  <th>Son Ödeme Tarihi</th>
                  <th>Açıklama</th>
                  <th>Tutar</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="Taksit in Taksitler">
                  <td>{{Taksit.Sira}}</td>
                  <td>{{Taksit.sTarihiText}}</td>
                  <td>{{Taksit.Aciklama}}</td>
                  <td>{{Taksit.TutarText}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <th colspan="3" class="text-right">Alt Toplam</th>
                  <th>{{AltToplam}}</th>
                </tr>
                </tfoot>
              </table>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>
<script>


  import Yukleniyor from "../../../Doc/Yukleniyor";
  import MakbuzDetay from "../../Vezne/MakbuzDetay";

  export default {
    props: ['Cari_id'],
    components: {MakbuzDetay, Yukleniyor},
    data() {
      return {
        MakbuzDetayModal: false,
        mNo: null,
        TekrarKapali: false,
        OdemeKapali: false,
        lo: false,
        Yetki: false,
        ModalOlayi: false,
        Kaydet: true,
        Sayfa: {
          ButtonAdi: 'Kaydet',
          Adi: 'Gider İşle',
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Arama: this.$t('eGenel.9'),
          Menu: [
            {Adi: 'Excel Yükle', Link: '/muhasebe/gider/excel'},
            {Adi: 'Abonelik İşle', Link: '/muhasebe/gider/abonelik'},
          ],
          MenuDisplay: true,
        },

        Form: {
          Bina_id: null,
          Cari_id: null,
          Kategori_id: null,
          sTarihi: null,
          tTarihi: null,
          Tutar: null,
          Aciklama: null,
          eNo: null,
          sKar: null,
          Tekrar: false,
          Odeme: false,
          oTarihi: null,
          Kasa_id: null,
          TekrarSayisi: 0,
          GunDongusu: 0,
          TaksitAdi: null,
          AyAdi: false,
          Bol: false,
          Daire: false,
          AnaPara: false,
          Taksitler: [],
          Tur: 1

        },
        FormHata: {
          Cari_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          tTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          sTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Binalar: [],
        Siteler: [],
        Cariler: [],
        Kategoriler: [],
        Taksitler: [],
        Kasalar: [],
        AnlasmaliFirmalar: [],
        AltToplam: null
      }
    },
    methods: {
      Submit() {
        this.$refs['GiderForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.Form.Tekrar) this.Form.Taksitler = this.Taksitler; else this.Form.Taksitler = null;
            this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/gider/gider'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  this.Form.Tarih = response.Tur;

                  if (response.Odeme) {
                    this.MakbuzDetayModal = true;
                    this.mNo = response.Odeme.mNo;
                    this.$emit('mNo', this.mNo);
                  } else {
                    this.$emit('Kapat', true);
                  }
                  this.Sifirla();
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })

      },
      Sifirla() {
        var Gun = new Date();
        var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);

        this.Form = {
          Bina_id: null,
          Sitemi: false,
          Cari_id: null,
          Kategori_id: null,
          sTarihi: AySonu,
          tTarihi: Gun,
          Tutar: null,
          Aciklama: null,
          eNo: null,
          sKar: null,
          Tekrar: false,
          TekrarSayisi: 0,
          GunDongusu: 0,
          TaksitAdi: null,
          AyAdi: false,
          AnaPara: false,
          Bol: false,
          Daire: false,
          Tur: 1,
          Taksitler: []
        };
        if (this.$store.getters.BinaBilgi) {
          this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
          this.BinaSecimi()
        }
      },
      BinaSecimi() {
        this.Sitemi = this.Siteler.filter(c => c.id.includes(this.Form.Bina_id))[0] ? true : false;
        this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.Form.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kasalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/bina/anlasma/' + this.Form.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.AnlasmaliFirmalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
      Anlasma(Detay) {
        this.Form.Cari_id = Detay.Cari_id;
        this.Form.Kategori_id = Detay.Kategori_id;
        this.Form.Aciklama = Detay.Aciklama;
      },
      TaksitPlani() {
        this.lo = true
        this.Form.Taksitler = null;
        this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/taksit'})
          .then(response => {
            this.lo = false
            if (response.Durum == "OK") {
              this.Taksitler = response.Data;
              this.Kaydet = true;
              if (this.Form.AnaPara)
                this.AltToplam = this.Form.Tutar
              else
                this.AltToplam = (this.Form.Tutar * this.Form.TekrarSayisi)
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      SayfaYukle() {
        this.lo = true
        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/cari'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Cariler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
          .then(response => {
            this.lo = false
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }
    },
    created() {
      if (this.Cari_id) this.Form.Cari_id = this.Cari_id;
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
      this.$store.commit("SayfaBilgi", this.Sayfa);
      this.SayfaYukle();
      //+'.'+Gun.getMonth()+'.'+Gun.getFullYear()
      var Gun = new Date();
      var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      this.Form.tTarihi = Gun;
      this.Form.sTarihi = AySonu;
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
        this.BinaSecimi()
      }
      if (this.$route.path == '/muhasebe/gelir') {
        this.Sayfa.MenuDisplay = false;
        this.Sayfa.Adi = 'Gelir İşle';
        this.Form.Tur = 2;
      } else {
        this.Sayfa.MenuDisplay = true;
        this.Sayfa.Adi = 'Gider İşle';
        this.Form.Tur = 1
      }

    },
    computed: {
      Tutar() {
        return this.Form.Tutar
      },
      Tekrar() {
        return this.Form.Tekrar
      },
      Odeme() {
        return this.Form.Odeme
      }
    },
    watch: {
      Tutar() {
        if (this.Form.Tutar) this.Form.Tutar = this.Form.Tutar.replace(",", ".");
        //console.log(this.Form.Tutar);
      },
      Tekrar() {
        if (this.Form.Tekrar) {
          this.Kaydet = false;
          this.OdemeKapali = true;
        } else {
          this.Kaydet = true;
          this.OdemeKapali = false;
        }
        //console.log(this.Form.Tutar);
      },
      Odeme() {
        if (this.Form.Odeme) {
          this.TekrarKapali = true;
        } else {
          this.TekrarKapali = false
        }
        //console.log(this.Form.Tutar);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/gider/GiderIsleComp.vue